import { TableCell, TableRow, Typography } from '@mui/material';
import { ReactNode } from '@tanstack/react-router';

export interface EmployeesActionsSlotPayload {
  token: string;
}

interface Props {
  token: string;
  email: string;
  actionsSlot: (payload: EmployeesActionsSlotPayload) => ReactNode;
}

export const EmployeesGroupDetailsEmployeesTableRow = ({
  token,
  email,
  actionsSlot,
}: Props) => {
  return (
    <TableRow>
      <TableCell>
        <Typography variant="inherit">{email || '-'}</Typography>
      </TableCell>

      <TableCell align="right" sx={{ cursor: 'default' }}>
        {actionsSlot({ token })}
      </TableCell>
    </TableRow>
  );
};
